var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22654 18.5015C3.70178 18.5015 3.25461 18.3168 2.88504 17.9472C2.51547 17.5776 2.33069 17.1305 2.33069 16.6057V5.05861C2.33069 4.53385 2.51547 4.08668 2.88504 3.71711C3.25461 3.34755 3.70178 3.16276 4.22654 3.16276H5.00008V1.49609H6.78133V3.16276H13.2188V1.49609H15.0001V3.16276H15.7736C16.2984 3.16276 16.7456 3.34755 17.1151 3.71711C17.4847 4.08668 17.6695 4.53385 17.6695 5.05861V16.6057C17.6695 17.1305 17.4847 17.5776 17.1151 17.9472C16.7456 18.3168 16.2984 18.5015 15.7736 18.5015H4.22654ZM4.22654 16.6057H15.7736V8.33216H4.22654V16.6057ZM4.22654 6.66549H15.7736V5.05861H4.22654V6.66549Z",
    fill: "#909092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.69705975a8d8c40373708a731dd74aab.svg";
export { ForwardRef as ReactComponent };